// Shared react-select menu surface for the customer forms.
//
// react-select's default menu is a 4px-radius box, which reads as harsh next to
// the 10px controls the rest of the form uses. SchoolInput and GradeInput both
// need the same treatment and sit on the same screen, so the definition lives
// here rather than being pasted into each -- two copies of a look drift, and
// then one dropdown is round and its neighbour isn't.
//
// Pair menu + menuList: the radius goes on the menu, `overflow: hidden` clips
// the first/last option's background to it (otherwise a focused row paints
// square corners back over the curve), and the list's vertical padding keeps a
// highlighted row from touching the curve at all.

// Matches controlBase in SchoolInput/GradeInput (10px) and the control's border.
const RADIUS = '10px';
const BORDER_COLOR = '#e2e8f0';

export const menuSurface = (provided) => ({
  ...provided,
  borderRadius: RADIUS,
  border: `1px solid ${BORDER_COLOR}`,
  // Softer and wider than react-select's default so the menu reads as floating
  // above the form rather than boxed onto it.
  boxShadow: '0 12px 28px rgba(15, 23, 42, 0.12)',
  overflow: 'hidden',
  marginTop: '6px',
  zIndex: 20,
});

export const menuListSurface = (provided) => ({
  ...provided,
  borderRadius: RADIUS,
  paddingTop: '4px',
  paddingBottom: '4px',
});
